export default __webpack_public_path__ + "static/media/noexpl_09_DE.f6420f65.png";